module.exports = __webpack_public_path__ + "img/138.4.07201250.png";